<lib-ph-bhp-managepuzzles [userData]="appConfig.userData" (childData)=onChildData($event)></lib-ph-bhp-managepuzzles>